import React, { useEffect, useState } from 'react';
import './Header.scss';
import { SectionInterface } from '../../interfaces/SectionInterface';

const Header: React.FC<SectionInterface> = ({ sectionProp }) => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const sectionIds = ['home', ...sectionProp.map((section) => section.route)];
    const sections = sectionIds
      .map((id) => document.getElementById(id))
      .filter((section): section is HTMLElement => Boolean(section));
    let animationFrame: number | null = null;

    const updateActiveSection = () => {
      const readingLine = window.scrollY + (window.innerHeight * 0.32);
      const isAtPageEnd = window.scrollY + window.innerHeight
        >= document.documentElement.scrollHeight - 4;
      let currentSection = sections[0];

      sections.forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        if (sectionTop <= readingLine) currentSection = section;
      });

      if (isAtPageEnd) currentSection = sections[sections.length - 1];
      if (currentSection) setActiveSection(currentSection.id);
    };

    const handlePositionChange = () => {
      if (animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(() => {
        updateActiveSection();
        animationFrame = null;
      });
    };

    updateActiveSection();
    window.addEventListener('scroll', handlePositionChange, { passive: true });
    window.addEventListener('resize', handlePositionChange);

    return () => {
      window.removeEventListener('scroll', handlePositionChange);
      window.removeEventListener('resize', handlePositionChange);
      if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);
    };
  }, [sectionProp]);

  return (
    <header className="site-header">
      <a
        className="site-brand"
        href="#home"
        aria-label="Jason Conci, home"
        aria-current={activeSection === 'home' ? 'location' : undefined}
      >
        <span className="site-brand-mark" aria-hidden="true">JC</span>
        <span className="site-brand-name">Jason Conci</span>
      </a>

      <nav className="site-navigation" aria-label="Main navigation">
        {sectionProp.map((section, index) => {
          const isActive = activeSection === section.route;

          return (
            <a
              key={section.route}
              className={`site-navigation-link${isActive ? ' is-active' : ''}`}
              href={`#${section.route}`}
              aria-current={isActive ? 'location' : undefined}
            >
              <span aria-hidden="true">{section.order ?? `0${index + 1}`}.</span>
              {section.name}
            </a>
          );
        })}
      </nav>
    </header>
  );
};

export default Header;
